



















import { Component, Vue, Prop } from 'vue-property-decorator';
import SelectUser from '@/components/selectUser.vue';

type IUserInfo = IUser.IResponse.IUserDetailInfo;

@Component({
  components: {
    SelectUser,
  },
})
export default class EditUsers extends Vue {
  @Prop({required: true}) private type!: 'add' | 'del';
  private mode = 'multiple';
  private loading = false;
  private selectedList: string[] = [];
  private removedList: string[] = [];
  private currentUsers: IUserInfo[] = [];
  @Prop({default: () => []}) private users!: IUserInfo[];
  @Prop({required: true}) private submitAddUsers!: (
    userIds: string[],
  ) => Promise<string>;
  @Prop({required: true}) private submitDelUsers!: (
    userIds: string[],
  ) => Promise<string>;
  private created() {
    this.resetEdit();
  }
  // 获取当前的UserIds
  get currentUserIds() {
    return this.currentUsers.map((user) => user.id);
  }
  // 处理选项改变，添加权限
  private handleChange(value: string[]) {
    if (this.mode === 'multiple') {
      this.selectedList = value;
    }
  }
  // 重置编辑数据
  private resetEdit() {
    this.selectedList = [];
    this.removedList = [];
    this.currentUsers = [...this.users];
  }
  // 删除用户
  private removeCurrentUsers(userId: string) {
    const newcurrentUsers = this.currentUsers.filter((user) => user.id !== userId);
    this.currentUsers = newcurrentUsers;
    this.removedList.push(userId);
  }
  private handleAddUsers() {
    if (this.selectedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitAddUsers(this.selectedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
  private handleDelUsers() {
    if (this.removedList.length <= 0) {
      this.$emit('ok');
      return;
    }
    this.loading = true;
    this.submitDelUsers(this.removedList).then((res) => {
      this.$message.success(res);
      this.loading = false;
      this.$emit('ok');
    }).catch((err) => {
      this.loading = false;
      this.$message.warning(err);
    });
  }
}
